import { render, staticRenderFns } from "./BorderLink.vue?vue&type=template&id=388008c6&scoped=true&"
import script from "./BorderLink.vue?vue&type=script&lang=js&"
export * from "./BorderLink.vue?vue&type=script&lang=js&"
import style0 from "./BorderLink.vue?vue&type=style&index=0&id=388008c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388008c6",
  null
  
)

export default component.exports